import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import {
  OFF_PLATFORM_PAYMENT_WARNING,
  ON_PLATFORM_PAYMENT_POLICY_PREVIEW_LINK
} from '../utils/constants';

export default function OffPlatformPaymentMessage({ className }) {
  return (
    <div className={classNames('OffPlatformPaymentMessage font-12', className)}>
      <span>{OFF_PLATFORM_PAYMENT_WARNING}</span>{' '}
      <a
        className="stone-700 underline"
        href={ON_PLATFORM_PAYMENT_POLICY_PREVIEW_LINK.url}
        target="_blank"
        rel="noreferrer"
      >
        Learn&nbsp;more
      </a>
    </div>
  );
}

OffPlatformPaymentMessage.propTypes = {
  className: PropTypes.string
};

OffPlatformPaymentMessage.defaultProps = {
  className: null
};
